export default __webpack_public_path__ + "static/media/Snd_ClowerH.ab090bb2.mp3";